import WizardModalTemplate, { WizardStep } from 'v2/components/WizardModal/WizardModalTemplate';
import AlmostReadyStep from './modal/AlmostReadyStep';
import ConnectEntraIDStep from './modal/ConnectEntraIDStep';
import SyncingUsersStep from './modal/SyncingUsersStep';
import WaitingForPermissionsStep from './modal/WaitingForPermissionsStep';

interface ConnectEntraWizardProps {
  initialStep?: number;
}

const ConnectEntraWizard: React.FC<ConnectEntraWizardProps> = ({ initialStep = 0 }) => {
  const stepsEntra: WizardStep[] = [
    { label: 'Connect Entra' },
    { label: 'Permissions' },
    { label: 'Synchronizing users' },
    { label: 'Finish' }
  ];

  return (
    <WizardModalTemplate title="Link Entra" steps={stepsEntra} initialStep={initialStep} hideCloseButton>
      <ConnectEntraIDStep />
      <WaitingForPermissionsStep />
      <SyncingUsersStep />
      <AlmostReadyStep />
    </WizardModalTemplate>
  );
};

export default ConnectEntraWizard;
